import React from 'react';
import { Box, styled } from '@mui/material';
import { CollectionGridProductItem } from './CollectionGridProductItem';
import { CollectionGridWrapperProps } from '../../../models/Collection';

const CollectionItemWrapper = styled(Box)(() => ({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
}));

const CollectionItem = styled(Box)(() => ({
    padding: '5px',
    alignItems: 'stretch',
}));

export const CollectionGridWrapper: React.FC<CollectionGridWrapperProps> = (
    props
) => {
    const { products, handle, gridSize } = props;

    return (
        <CollectionItemWrapper>
            {products.map((item) => {
                return (
                    <CollectionItem
                        key={item.id}
                        sx={{ width: Number(100 / gridSize) + '%' }}
                    >
                        <CollectionGridProductItem
                            product={item}
                            handle={handle}
                        />
                    </CollectionItem>
                );
            })}
        </CollectionItemWrapper>
    );
};
